import React from 'react';

import safari_popups_image from '../../assets/frontend/images/safari_popups.jpeg';

function About() {
	return (
		<div className="body-content bg-fff pt-80l-70m-60s pb-120">

			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-left">
						<div className="font-libre-baskerville font-size-24l-20m-16s font-weight-800 bb1-555 pb-5">About</div>
					</div>
				</div>
			</div>

			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ddd p-20l-10s">
					<div className="large-12 medium-12 small-12 cell">
						<div className="font-libre-baskerville font-size-18l-16m font-weight-600 justify line-height-120per">
						Meet Feliz Garcia						
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
						Feliz Garcia is the founder of Love Leads the Way Radio and Podcast, a faith based ministry created to share God’s love through Christian radio, a podcast with meaningful conversations, prayer, and community.
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
						After nearly 20 years serving in public education, Feliz felt called to step into a new season of ministry with a desire to create a space where people feel encouraged, supported, and reminded that God is present in every season of life.
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
							Through Love Leads the Way Radio, Feliz shares uplifting Christian music, faith filled conversations, and messages of hope, healing, and encouragement. She is also the host of the podcast Sharing Your Miraculous Life, where guests share real stories of faith, transformation, and the moments where God’s love has changed their lives.
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
							Feliz is a devoted Catholic and an active member of her church community as a member of the ACTS ministry. God has guided her to start this ministry with a simple purpose: to create a space where faith grows, hearts are encouraged, and people are reminded they are never walking alone.
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
							Feliz believes every story matters, every prayer matters, and every step of faith matters. Her passion is helping others grow closer to Jesus through conversations, encouragement, and reminders of God’s unfailing love.
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
							The message is simple:
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
							God is Love, and Love Leads the Way. Walking with Jesus one step at a time, together.
						</div>
					</div>
				</div>
			</div>

			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ddd p-20l-10s">
					<div className="large-12 medium-12 small-12 cell">
						<div className="font-libre-baskerville font-size-18l-16m font-weight-600 justify line-height-120per">
						Meet Travis Serna						
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
						Travis Serna is an author, speaker, and mental health advocate with a passion for helping others find hope, healing, and purpose through faith. As the author of "Anxiety? 
						Not Me!", Travis shares his personal journey from denial and struggle to understanding and healing, encouraging others to break the stigma surrounding mental health and 
						seek support without shame.						
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
						Professionally, Travis has built a diverse career spanning physical therapy, cardiac rehabilitation, environmental safety, and nuclear operations. 
						He holds a Master's degree in Exercise Physiology and has spent much of his life serving others through both his work and his ministry.						
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
						A devoted Catholic and an active member of his church community, Travis serves as a lector and usher and participates in organizations that 
						strengthen faith and fellowship. His message is simple yet powerful: no one is alone in their struggles, and God's love and grace can bring 
						hope even in life's most difficult seasons.
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
						Through his writing, speaking engagements, and now as a member of this faith-based radio ministry, Travis seeks to inspire listeners to embrace 
						honest conversations about faith, mental health, and personal growth. His heartfelt approach combines real-life experiences, practical wisdom, 
						and biblical truth to remind people that healing is possible and that God can transform even our greatest challenges into a testimony of hope.						
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
						Travis is also the proud father of three children- Julian, Theodore, and Gianna- who continually inspire him to live with faith, purpose, 
						and compassion for others.
						</div>
					</div>
				</div>
			</div>

			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ddd p-20l-10s">
					<div className="large-12 medium-12 small-12 cell">
						<div className="font-libre-baskerville font-size-18l-16m font-weight-600 justify line-height-120per">
						Meet Carrie Aboytes						
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
						Carrie is a mom with three grown boys, a beautiful daughter-in-law and a precious grandson and a granddaughter on the way. 
						She is passionate about preserving the joy and the happiness we freely experience as children. Rejoice and Be Glad is her 
						way of serving her neighbors, reminding them that they are never alone, and sharing the joy, the love and light of the Father. 
						She is always smiling and wants her faith to be alive - to dance, to sing and to love with everything that she is! Every day is 
						a new opportunity to continue to grow and learn so that she can be a better Carrie tomorrow than she is today. She has daily 
						conversations with the Father, counts her blessings constantly, tries to embrace every day with her whole heart, and believes 
						with every fiber of her being in the power of a cha-cha! One of these days, she's gonna paint the whole world yellow! 						
						</div>
					</div>
				</div>
			</div>

		</div>
	);
}

export default About;